import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/auth/Login.vue'), meta: { public: true } },
  { path: '/register', component: () => import('@/views/auth/Register.vue'), meta: { public: true } },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/home',
    children: [
      { path: 'home', component: () => import('@/views/home/Index.vue') },
      { path: 'lottery', component: () => import('@/views/lottery/Index.vue') },
      { path: 'company', component: () => import('@/views/company/Index.vue') },
      { path: 'game', component: () => import('@/views/game/Index.vue') },
      { path: 'profile', component: () => import('@/views/profile/Index.vue') },
      { path: 'checkin', component: () => import('@/views/checkin/Index.vue') },
      { path: 'upgrade', component: () => import('@/views/upgrade/Index.vue') },
      { path: 'team', component: () => import('@/views/team/Index.vue') },
      { path: 'recharge', component: () => import('@/views/recharge/Index.vue') },
      { path: 'withdraw', component: () => import('@/views/withdraw/Index.vue') },
      { path: 'kyc', component: () => import('@/views/kyc/Index.vue') },
      { path: 'logs', component: () => import('@/views/logs/Index.vue') },
      { path: 'orders', component: () => import('@/views/orders/Index.vue') },
      { path: 'rebates', component: () => import('@/views/rebates/Index.vue') },
      { path: 'news', component: () => import('@/views/news/Index.vue') },
      { path: 'news/:id', component: () => import('@/views/news/Detail.vue') },
      { path: 'legal', component: () => import('@/views/legal/Index.vue'), meta: { pageKey: 'legal' } },
      { path: 'business-reward', component: () => import('@/views/legal/Index.vue'), meta: { pageKey: 'business_reward' } }
    ]
  }
]

function scrollToTop() {
  const x = window.pageXOffset || document.documentElement.scrollLeft || 0
  const y = window.pageYOffset || document.documentElement.scrollTop || 0
  if (x || y) {
    window.scrollTo(0, 0)
  }
  if (document.documentElement) document.documentElement.scrollTop = 0
  if (document.body) document.body.scrollTop = 0
}

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!store.state.token) return next('/login')
  next()
})

// hash + 移动端 WebView 下 scrollBehavior 偶发不生效，afterEach 再兜一层
router.afterEach((to, from) => {
  if (to.path === from.path) return
  Vue.nextTick(() => {
    scrollToTop()
    // 子页异步内容撑开高度后再滚一次，避免仍停在旧位置
    setTimeout(scrollToTop, 50)
  })
})

export default router
